export const name = "TIME_ADD";
export const summary = `Adds a specified time interval to a \`TIME\` value.`;
export const reference = `
## TIME_ADD

Adds a specified time interval to a \`TIME\` value.

\`\`\`
TIME_ADD(time_expression, INTERVAL int64_expression part)
\`\`\`

### Description

Adds \`int64_expression\` units of \`part\` to the \`TIME\` object.

\`TIME_ADD\` supports the following values for \`part\`:

- \`MICROSECOND\`
- \`MILLISECOND\`
- \`SECOND\`
- \`MINUTE\`
- \`HOUR\`

This function automatically adjusts when values fall outside of the 00:00:00 to 24:00:00 boundary. For example, if you add an hour to \`23:30:00\`, the returned value is \`00:30:00\`.


### Return Data Types

\`TIME\`


### Example



\`\`\`
SELECT
  TIME "15:30:00" as original_time,
  TIME_ADD(TIME "15:30:00", INTERVAL 10 MINUTE) as later;

/*-----------------------------+------------------------*
 | original_time | later |
 +-----------------------------+------------------------+
 | 15:30:00 | 15:40:00 |
 *-----------------------------+------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
`;
